import { Theme } from "@mui/material";
import { SxObjType } from "lib/theme/types/SxObjType.type";

export const sxStyles = (theme: Theme) =>
  ({
    container: {
      bgcolor: theme.palette.secondary.light,
      p: "10px",
      flexDirection: "row",
      justifyContent: "space-between",
      display: "flex",
    },
    leftPanel: {
      display: "flex",
      gap: 2,
      flexDirection: "column",
    },
    detailsText: {
      typography: theme.typography.body2_semibold,
      color: theme.palette.grey[600],
    },
  }) as const satisfies SxObjType;
